"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteStreamAptosOperation = void 0;
exports.deleteStreamAptosOperation = {
    method: 'DELETE',
    name: 'deleteStreamAptos',
    id: 'aptosStreamsDelete',
    groupName: 'aptosStreams',
    urlPathParamNames: ['id'],
    urlPathPattern: "/streams/aptos/{id}",
    bodyParamNames: [],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        id: request.id,
    };
}
function getRequestBody() {
    return {};
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request) {
    return {
        id: request.id,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        id: jsonRequest.id,
    };
}
//# sourceMappingURL=deleteStreamAptosOperation.js.map